
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2023-09-10-webstudio-part-1",
      function () {
        return require("private-next-pages/blogs/2023-09-10-webstudio-part-1/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2023-09-10-webstudio-part-1"])
      });
    }
  